import { BackendHttpService } from "../backendHttpService";

export class EmployersDictionaryService extends BackendHttpService {
    private employersCache: string[] | null = null;

    constructor() {
        super("WorkExperience");
    }

    async getEmployersDictionary(): Promise<string[]> {
        if (this.employersCache) {
            return this.employersCache;
        }
        try {
            this.employersCache = Array.from(new Set(
                (await this.get<string[]>("/employersDictionary"))
                    .filter((e): e is string => !!e?.trim())
                    .map((e) => e.trim())
            ));
            return this.employersCache;
        } catch (error) {
            console.error("Error getting employers dictionary:", error);
            throw error;
        }
    }

    clearCache(): void {
        this.employersCache = null;
    }
}

export const employersDictionaryService = new EmployersDictionaryService();
